import React, {useState} from 'react';
import PhoneInput from 'react-phone-input-2';
import {makeStyles} from '@material-ui/core';

interface PhoneNumberFormatterProps {
  value: string;
}

const styles = makeStyles(() => ({
  phoneInput: {
    display: 'none'
  },
  formattedPhoneNumber: {
    // PHONE NUMBER SHOULD NEVER WRAP
    whiteSpace: 'nowrap'
  }
}));

function toPhoneInputValue(value: string): string {
  const digits = (value || '').replace(/\D/g, '');
  if (digits.length === 10) {
    return `1${digits}`;
  }
  return digits;
}

const PhoneNumberFormatter = (
  props: PhoneNumberFormatterProps
): React.ReactElement => {
  const {value, ...rest} = props;
  const classes = styles();
  const phoneInputValue = toPhoneInputValue(value);
  const [formattedPhoneNumber, setFormattedPhoneNumber] = useState(value);
  return (
    <>
      {/* HIDING THE COMPONENT BECAUSE, IT WAS NOT INHERITING STYLES FROM ITS PARENT AND SOME STYLES WERE NOT GETTING OVERRIDDEN */}
      <PhoneInput
        containerClass={classes.phoneInput}
        {...rest}
        value={phoneInputValue}
        disabled
        enableLongNumbers
        specialLabel=""
        onMount={(_phoneValue, _country, formattedValue) => {
          if (formattedValue) {
            setFormattedPhoneNumber(formattedValue);
          }
        }}
        // PASSING A KEY VALUE SO THAT `PhoneInput` WILL BE RE-RENDERED WHEN THE VALUE CHANGES SO AS TO CHANGE THE WIDTH OF THE ELEMENT
        key={phoneInputValue}
      />
      <span className={classes.formattedPhoneNumber}>
        {formattedPhoneNumber}
      </span>
    </>
  );
};

export default PhoneNumberFormatter;
